export const copyToClipboard = (text)=>{
  window.navigator.clipboard.writeText(text)
}
